import { ContentType, request } from "../api";
import { baseParams } from "../common";

export const activateByToken = async (data = {}, params = {}) => request({
  path: "/activate-by-token",
  method: "POST",
  body: { ...baseParams, ...data },
  type: ContentType.Json,
  format: "json",
  ...params,
});
